<template>
  <div id="daily-labor-record" ref="crewLaborRecord">
    <div class="crew-labor-record-table h-full overflow-hidden">
      <vs-row
        id="daily-labor-record-header"
        vs-w="12"
        class="mt-4 gap-4"
        ref="crewLaborRecordHeader"
      >
        <div
          class="vessel-name flex flex-start items-center aisea-text-16-700-black mr-12"
        >
          {{ vesselName }}
        </div>
        <!-- 年月 -->
        <div class="year-month-dropdown flex flex-start items-center flex-grow">
          <div
            class="mr-3 aisea-text-14-400-blue cursor-pointer select-none"
            @click="() => addSelectedDate(-1)"
          >
            前の日付
          </div>
          <date-picker
            :value.sync="selectedDate"
            placeholder="2022/01/30"
            dateFormat="Y/m/d"
          ></date-picker>
          <div
            class="ml-3 aisea-text-14-400-blue cursor-pointer select-none"
            @click="() => addSelectedDate(1)"
          >
            後の日付
          </div>
        </div>
        <!-- ダウンロードボタン -->
        <div class="flex flex-start items-center">
          <button
            type="button"
            class="vs-button includeIcon download-btn"
            style=""
            @click.stop.prevent="() => handleClickDownload()"
            :disabled="isRecordBookNotFound"
          >
            <feather-icon
              icon="DownloadIcon"
              svgClasses="h-4 w-4"
              class="mr-2"
            />
            <span class="vs-button-text vs-button--text"> ダウンロード </span>
          </button>
        </div>
      </vs-row>

      <!-- 作業グラフなどのテーブル -->
      <div
        id="labor-record-table"
        class="flex flex-col overflow-x-auto mt-6"
        ref="crewReborRecordTable"
        v-if="!isRecordBookNotFound"
      >
        <div id="record-header" class="flex flex-shrink-0 sticky z-40">
          <div class="date flex items-end aisea-text-12-400-gray z-50">
            職名
          </div>
          <div
            class="
              working-graph
              flex flex-col
              justify-end
              items-start
              flex-shrink-0
              gap-2
              aisea-text-12-400-dark-gray
            "
          >
            <div>作業グラフ</div>
            <div class="timeline flex flex-shrink-0">
              <div
                v-for="(n, index) of cellNum"
                :key="`${n}-${index}`"
                class="timeline-cell text-center"
              >
                {{ index }}
              </div>
            </div>
          </div>

          <div
            class="
              aisea-text-12-400-gray
              working-hours-per-day
              flex
              items-end
              justify-center
            "
          >
            1日当たりの労働時間
          </div>
          <div
            class="
              aisea-text-12-400-gray
              overtime-work
              flex
              items-end
              justify-center
            "
          >
            時間外労働
          </div>
          <div
            class="
              aisea-text-12-400-gray
              overtime-work
              flex
              items-end
              justify-center
            "
          >
            連続休息時間
          </div>
          <div
            class="
              aisea-text-12-400-gray
              compensation-holiday-work
              flex
              items-end
              justify-center
            "
          >
            過去4日間以内の労働時間
          </div>

          <div
            class="
              aisea-text-12-400-gray
              working-hours-per-week
              flex
              items-end
              justify-center
            "
          >
            過去5日間以内の労働時間
          </div>
          <div
            class="
              aisea-text-12-400-gray
              working-hours-per-week
              flex
              items-end
              justify-center
            "
          >
            過去6日間以内の労働時間
          </div>
          <div
            class="
              aisea-text-12-400-gray
              working-hours-per-week
              flex
              items-end
              justify-center
            "
          >
            過去7日間以内の労働時間
          </div>
          <div
            class="
              aisea-text-12-400-gray
              working-hours-per-week
              flex
              items-end
              justify-center
            "
          >
            過去28日間の時間外労働
          </div>
        </div>
        <!-- 行のデータ -->
        <div id="record-body" class="flex flex-col flex-shrink-0">
          <vessel-labor-record-row
            v-for="(dataRecord, index) in rowData"
            :key="index"
            :momentObj="dataRecord.momentObj"
            :roleName="dataRecord.roleName"
            :onClickRoleName="() => onClickRoleName(dataRecord.id)"
            :cellSize="cellSize"
            :cellNum="cellNum"
            :dailyWorkingTime="dataRecord.dailyWorkingTime"
            :dailyOvertime="dataRecord.dailyOvertime"
            :maxOfDividedRestTime="dataRecord.maxOfDividedRestTime"
            :fourDaysWorkingTime="dataRecord.fourDaysWorkingTime"
            :fiveDaysWorkingTime="dataRecord.fiveDaysWorkingTime"
            :sixDaysWorkingTime="dataRecord.sixDaysWorkingTime"
            :sevenDaysWorkingTime="dataRecord.sevenDaysWorkingTime"
            :twentyEightDaysOvertime="dataRecord.twentyEightDaysOvertime"
            :isHourOfOvertimeWorkTwentyEightDaysCritical="
              dataRecord.isHourOfOvertimeWorkTwentyEightDaysCritical
            "
            :isHourOfRestTwentyFourHoursCritical="
              dataRecord.isHourOfRestTwentyFourHoursCritical
            "
            :isHourOfWorkOneWeekCritical="
              dataRecord.isHourOfWorkOneWeekCritical
            "
            :isHourOfWorkOneWeekWarning="dataRecord.isHourOfWorkOneWeekWarning"
            :isHourOfWorkFourDaysWarning="
              dataRecord.isHourOfWorkFourDaysWarning
            "
            :isHourOfWorkFiveDaysWarning="
              dataRecord.isHourOfWorkFiveDaysWarning
            "
            :isHourOfWorkSixDaysWarning="dataRecord.isHourOfWorkSixDaysWarning"
            :timesheetList="dataRecord.timesheetList"
            :warningHours="dataRecord.warningHours"
            :criticalHours="dataRecord.criticalHours"
            :taskTimes="dataRecord.taskTimes"
            :enterpriseCrewId="dataRecord.enterpriseCrewId"
          />
        </div>
      </div>
      <div class="flex flex-col items-center justify-center h-full" v-else>
        <div class="aisea-text-16-400-gray my-20">
          連携対象期間外のデータは表示されません
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import moment from "moment-timezone";
import VesselLaborRecordRow from "../components/VesselLaborRecordRow";
import DatePicker from "../../components/DatePicker.vue";
import { DeviceInfoMixin, ColorMixin } from "@/mixins";
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("crewLabor");
import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const enterpriseOwnerManningCrewApi = AiseaApiFactory.get(
  "enterpriseOwnerManningCrew"
);
const enterpriseOwnerManningVesselRecordBookApi = AiseaApiFactory.get(
  "enterpriseOwnerManningVesselRecordBook"
);
const enterpriseTimesheetTaskApi = AiseaApiFactory.get(
  "enterpriseTimesheetTask"
);
const enterpriseOwnerManningVesselApi = AiseaApiFactory.get(
  "enterpriseOwnerManningVessel"
);

import FileSaver from "file-saver";

export default {
  name: "DailyLaborRecord",
  components: {
    VesselLaborRecordRow,
    DatePicker,
  },
  props: {
    cellSize: { type: Number, default: 30 },
    cellNum: { type: Number, default: 24 },
  },
  mixins: [DeviceInfoMixin, ColorMixin],
  data() {
    return {
      selectedDate: moment()
        .startOf("day")
        .toDate(),
      anonymusCrews: [],
      recordBooks: [],
      taskKindList: [],
      showDownloadDialog: false,
      vesselName: null,
      isFetchingData: false,

      isRecordBookNotFound: false,
    };
  },
  watch: {
    selectedDate() {
      this.setUp();
    },
  },
  computed: {
    ...mapState(["labors"]),
    ...mapState(["manningVessels", "crewRoles"]),

    rowData() {
      // データ取得中に自動計算で正しくないグラフが表示されるため、データ取得中は空の配列を返す
      if (this.isFetchingData) {
        return [];
      }
      // crewsとrecordBooksを結合して、行データを作成する
      return this.anonymusCrews.map(crew => {
        const targetRecordBook = this.recordBooks.find(
          recordBook => recordBook.enterprise_crew_id === crew.id
        );

        const targetInlineRecordBook = targetRecordBook
          ? targetRecordBook.inline_response_enterprise_crew_record_books[0]
          : null;

        const taskTimes = this.taskKindList.map(task => {
          if (targetInlineRecordBook && targetInlineRecordBook.task_times) {
            const taskTime = targetInlineRecordBook.task_times.find(
              taskTime => taskTime.id === task.id
            );
            return {
              id: task.id,
              minutes: taskTime ? taskTime.minutes : 0,
              color_hex: task.color_hex,
              label: task.label,
            };
          } else {
            return {
              id: task.id,
              minutes: 0,
              color_hex: task.color_hex,
              label: task.label,
            };
          }
        });
        const timesheetList = targetInlineRecordBook
          ? targetInlineRecordBook.timesheet_list
          : [];

        const targetRole = crew.roles.slice().reverse().find(role => {
          return (
            moment(role.startOn).isSameOrBefore(moment(this.selectedDate)) &&
            moment(role.endOn).isSameOrAfter(this.selectedDate)
          );
        });

        return {
          id: crew.id,
          momentObj: moment(this.selectedDate).startOf("day"),
          taskTimes: taskTimes,
          roleName: targetRole ? targetRole.name : "不明",
          timesheetList: timesheetList,
          dailyWorkingTime: targetInlineRecordBook
            ? targetInlineRecordBook["daily_working_time"]
            : null,
          dailyOvertime: targetInlineRecordBook
            ? targetInlineRecordBook["daily_overtime"]
            : null,
          maxOfDividedRestTime: targetInlineRecordBook
            ? targetInlineRecordBook["max_of_divided_rest_time"]
            : null,
          fourDaysWorkingTime: targetInlineRecordBook
            ? targetInlineRecordBook["4days_working_time"]
            : null,
          fiveDaysWorkingTime: targetInlineRecordBook
            ? targetInlineRecordBook["5days_working_time"]
            : null,
          sixDaysWorkingTime: targetInlineRecordBook
            ? targetInlineRecordBook["6days_working_time"]
            : null,
          sevenDaysWorkingTime: targetInlineRecordBook
            ? targetInlineRecordBook["7days_working_time"]
            : null,
          twentyEightDaysOvertime: targetInlineRecordBook
            ? targetInlineRecordBook["28days_overtime"]
            : null,
          isHourOfOvertimeWorkTwentyEightDaysCritical: targetInlineRecordBook
            ? targetInlineRecordBook["is_hour_of_overtime_work28d_critical"]
            : null,
          isHourOfRestTwentyFourHoursCritical: targetInlineRecordBook
            ? targetInlineRecordBook["is_hour_of_rest24h_critical"]
            : null,
          isHourOfWorkOneWeekCritical: targetInlineRecordBook
            ? targetInlineRecordBook["is_hour_of_work1w_critical"]
            : null,
          isHourOfWorkOneWeekWarning: targetInlineRecordBook
            ? targetInlineRecordBook["is_hour_of_work1w_warning"]
            : null,
          isHourOfWorkFourDaysWarning: targetInlineRecordBook
            ? targetInlineRecordBook["is_hour_of_work4d_warning"]
            : null,
          isHourOfWorkFiveDaysWarning: targetInlineRecordBook
            ? targetInlineRecordBook["is_hour_of_work5d_warning"]
            : null,
          isHourOfWorkSixDaysWarning: targetInlineRecordBook
            ? targetInlineRecordBook["is_hour_of_work6d_warning"]
            : null,

          warningHours:
            targetInlineRecordBook && targetInlineRecordBook["warning_hours"]
              ? targetInlineRecordBook["warning_hours"]
              : [],
          criticalHours:
            targetInlineRecordBook && targetInlineRecordBook["critical_hours"]
              ? targetInlineRecordBook["critical_hours"]
              : [],
        };
      });
    },
  },
  methods: {
    async setUp() {
      this.$vs.loading({ color: this.AISEA_COLOR.BLUE });
      this.isFetchingData = true;
      const enterpriseManningVesselId = this.$route.params.id;
      Promise.all([
        this.fetchAnonymusCrews(),
        this.fetchRecordBooks(enterpriseManningVesselId),
      ])
        .catch(() => {
          this.$vs.notify({
            title: "データの取得に失敗しました",
            color: "danger",
            iconPack: "feather",
            icon: "icon-x-square",
          });
        })
        .finally(() => {
          this.$vs.loading.close();
          this.isFetchingData = false;
        });
    },
    onClickRoleName(crewId) {
      const routeData = this.$router.resolve({
        name: "enterprise-management-crew-operator-crew-labor-detail",
        params: { id: crewId },
      });
      window.open(routeData.href, "_blank");
    },
    // 日付の前後ボタンを押したときの処理
    addSelectedDate(addDay) {
      this.selectedDate = moment(this.selectedDate)
        .add(addDay, "day")
        .toDate();
    },

    async fetchTasks() {
      const res = await enterpriseTimesheetTaskApi.search({});
      if (res.status) {
        this.taskKindList = res.data.list.map(task => {
          return {
            id: task.id,
            // カスタム作業種別の場合はlabelをそのまま表示名として採用
            // デフォルト作業種別の場合はlabelをlocalizedKeyとして用いて表示名を取得
            label: task.is_custom
              ? task.label
              : this.$t(`Views.Crew.LaborRecord.Tasks.${task.label}`),
            localized_key: task.localized_key,
            is_alert_target: task.is_alert_target,
            show_on_record_book: task.show_on_record_book,
            sort_order: task.sort_order,
            used_by_record_book: task.used_by_record_book,
          };
        });
      } else {
        throw Error();
      }
    },
    async fetchAnonymusCrews() {
      const enterpriseManningVesselId = this.$route.params.id;
      const res = await enterpriseOwnerManningCrewApi.fetchCrews({
        from_date: moment(this.selectedDate).format("YYYY-MM-DD"),
        to_date: moment(this.selectedDate).format("YYYY-MM-DD"),
        vessel_ids: [enterpriseManningVesselId].toString(),
        size: 1000,
      });
      if (res.status) {
        this.anonymusCrews = res.data.enterprise_crews.map(crew => {
          return {
            id: crew.id,
            roles: crew.enterprise_manning_vessel_crew
              .map(vesselCrew =>
                vesselCrew.roles.map(role => {
                  return {
                    startOn: role.start_on,
                    endOn: role.end_on,
                    name: role.localized_key === "other" && role.name
                      ? role.name
                      : this.$t(`Views.Crew.${role.localized_key}`),
                  };
                })
              )
              .flat(2),
          };
        });
      } else {
        throw Error();
      }
    },
    async fetchRecordBooks(enterpriseManningVesselId) {
      const res = await enterpriseOwnerManningVesselRecordBookApi.fetchRecordBooks(
        enterpriseManningVesselId,
        {
          start_at: moment(this.selectedDate).format("YYYY-MM-DD"),
          end_at: moment(this.selectedDate).format("YYYY-MM-DD"),
        }
      );
      if (res.status) {
        this.recordBooks = res.data;
        this.isRecordBookNotFound = false;
      } else if (res.code === 404) {
        this.isRecordBookNotFound = true;
      } else {
        throw Error();
      }
    },

    async fetchCurrentVesselInfo(enterpriseManningVesselId) {
      const res = await enterpriseOwnerManningVesselApi.fetchVesselInfo(
        enterpriseManningVesselId
      );
      if (res.status) {
        this.vesselName = res.data.name;
      } else {
        throw Error();
      }
    },

    openDownloadModal() {
      this.downloadStartDate = moment(this.selectedDate).toDate();
      this.downloadEndDate = moment(this.selectedDate)
        .add(1, "month")
        .add(-1, "day")
        .toDate();
      this.showDownloadDialog = true;
    },
    closeDownloadDialog() {
      this.showDownloadDialog = false;
    },
    async handleClickDownload() {
      this.$vs.loading({ color: this.AISEA_COLOR.BLUE });
      const enterpriseManningVesselId = this.$route.params.id;
      const dateString = moment(this.selectedDate).format("YYYY-MM-DD");
      try {
        const res = await enterpriseOwnerManningVesselRecordBookApi.downloadDailyRecordBook(
          enterpriseManningVesselId,
          {
            date: dateString,
          }
        );
        if (res.status !== true) throw new Error();
        const fileName = `${this.vesselName}_運航船労務状況一覧（日次）${moment(
          this.selectedDate
        ).format("YYYYMMDD")}.xlsx`;
        FileSaver.saveAs(res.data, fileName);
        this.$vs.loading.close();
      } catch (e) {
        this.$vs.loading.close();
        this.$vs.notify({
          title: "ダウンロードに失敗しました",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square",
        });
      }
    },
  },
  async created() {
    this.$vs.loading({ color: this.AISEA_COLOR.BLUE });
    const enterpriseManningVesselId = this.$route.params.id;
    Promise.all([
      this.fetchTasks(),
      this.fetchAnonymusCrews(),
      this.fetchRecordBooks(enterpriseManningVesselId),
      this.fetchCurrentVesselInfo(enterpriseManningVesselId),
    ])
      .catch(() => {
        this.$vs.notify({
          title: "データの取得に失敗しました",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square",
        });
      })
      .finally(() => {
        this.$vs.loading.close();
      });
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";

#daily-labor-record {
  --vs-primary: 3, 155, 229;
  height: 100%;
  .vx-card {
    padding: 20px;
  }
  #daily-labor-record-header {
    .download-btn {
      border: 1px solid rgb(var(--vs-primary));
      background: transparent;
      color: rgb(var(--vs-primary));
      height: 2.7rem;
    }
  }
  #labor-record-table {
    #record-header {
      width: fit-content;
      top: 0;
      left: 0;
      height: 50px;
      border-bottom: 1px solid $aisea-light-gray;
      background-color: $aisea-pure-white;
      > div {
        position: sticky;
        top: 0;
        flex-shrink: 0;
        height: 49px;
        border-radius: 0px;
        padding: 0px, 20px, 0px, 10px;
        &:first-child {
          position: sticky;
          top: 0;
          left: 0;
        }
      }
      > div:not(.working-graph) {
        min-width: 80px;
        width: 80px;
        padding: 2px;
        padding-bottom: 10px;

        &.working-hours-per-day {
          padding: 9px;
        }

        &.date {
          min-width: 140px;
          padding: 4px 10px;
          background-color: $aisea-pure-white;
        }
      }

      .timeline-cell {
        height: 20px;
        min-width: 30px;
        border-left: solid 1px #e0e0e0;
        &:last-child {
          border-right: solid 1px #e0e0e0;
        }
      }
    }
    #record-body {
      width: fit-content;
    }
  }
}
</style>
